// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__176Ry","rootCenter":"LoadMoreObserver_rootCenter__Y-3vh","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__ghtFC"};